/**
 * Extracts the file extension from a given URL.
 * @param {string} url - The URL from which to extract the file type.
 * @returns {string | undefined} - The file extension if found, otherwise undefined.
 */
export const getFileType = (url: string): string | undefined => {
	const pathname = new URL(url).pathname;
	return pathname?.split('.').pop()?.split('%')[0];
};
